import dayjs from 'dayjs';

/**
 * dayjs 解析 ISO 日期字符串
 * @param dateStr 日期字符串
 * @param format 日期格式
 * @returns 格式化后的字符串或者 undefined
 */
export function parseIsoDate(dateStr?: string, format?: string): string | undefined {
  if (!dateStr) return undefined;

  const parsedDayjsTime = dayjs(dateStr);
  if (!parsedDayjsTime.isValid()) return undefined;

  if (format) {
    const formatTime = parsedDayjsTime.format(format);
    return formatTime;
  }

  return parsedDayjsTime.toISOString();
}

/**
 * 格式化 ISO 日期字符串
 * @param dateStr 日期字符串
 * @param format 格式化模板（例如 "YYYY-MM-DD HH:mm:ss"），可选
 * @returns 格式化后的字符串，如果传入的日期无效则返回 undefined
 */
export function formatIsoDate(dateStr?: string, format?: string): string | undefined {
  if (!dateStr) return undefined;

  const parsedDayjsTime = dayjs(dateStr);
  if (!parsedDayjsTime.isValid()) return undefined;

  return format ? parsedDayjsTime.format(format) : parsedDayjsTime.toISOString();
}

/**
 * 判断日期字符串是否是合法的时间格式
 * @param dateStr 日期字符串（例如 "2025-12-11T06:29:27Z"）
 * @returns 如果是合法的时间格式返回 true，否则返回 false
 */
export function isValidDateString(dateStr?: string): boolean {
  if (!dateStr) return false;

  const parsedDate = dayjs(dateStr);
  return parsedDate.isValid();
}
